export default "__VITE_ASSET__Zkl_7zbP__"